module.exports = __webpack_public_path__ + "img/2.4ee9c672.jpg";